import { render, staticRenderFns } from "./RowItemDemo.vue?vue&type=template&id=7f23a6fa"
import script from "./RowItemDemo.vue?vue&type=script&lang=js"
export * from "./RowItemDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports